import { useContext } from 'react';
import {
	ISearchbarContext,
	SearchbarContext
} from './../components/organisms/search-bar/search-bar.context';

export function useSearch(): ISearchbarContext {
	const context: ISearchbarContext | null =
		useContext<ISearchbarContext | null>(SearchbarContext);

	return context!;
}
